import { useContext } from "react"
import { AdminContext } from "~/contexts/AdminContext"
import useBreakpoint from "~/hooks/useBreakpoint"
import Spinner from "~/components/ui/Spinner"
import RentRollSummarySection from "~/components/Admin/Reports/ReportsRentRoll/RentRollSummarySection"
import RentRollMobileList from "~/components/Admin/Reports/ReportsRentRoll/RentRollCardList"
import RentRollTable from "~/components/Admin/Reports/ReportsRentRoll/RentRollTable"

export type iRentRollReport = {
  site_name: string
  camper_name: string
  lease_start_date: string
  lease_end_date: string
  monthly_rent: number
  electricity_fees: number
  other_charges: number
  service_fees: number
  credit_card_fees: number
  tax_fees: number
  total_owed: number
  total_paid: number
}

export type iRentRollSummaryReport = {
  total_monthly_rent: number
  total_owed: number
}

interface ComponentProps {
  data: iRentRollReport[]
  summary: iRentRollSummaryReport
  isLoading: boolean
}

const ReportsRentRoll = (props: ComponentProps) => {
  const { camp } = useContext(AdminContext)
  const isMobile = useBreakpoint("(max-width: 768px)")

  return (
    <div className="relative w-full">
      {props.isLoading && (
        <div className="z-20 absolute top-0 bg-transparent w-full h-full opacity-70 flex items-start pt-16 justify-center">
          <Spinner size={12} />
        </div>
      )}

      <div className="flex flex-col w-full" style={{ height: "calc(100vh - 270px)", minHeight: "400px" }}>
        <RentRollSummarySection summary={props.summary} camp={camp} isMobile={isMobile} />

        <div
          className="overflow-auto flex-grow relative border-y border-gray-100 scrollbar-thin"
          style={{
            scrollbarWidth: (isMobile && "none") || "auto",
          }}
        >
          {isMobile ? (
            <RentRollMobileList data={props.data} camp={camp} />
          ) : (
            <RentRollTable data={props.data} camp={camp} />
          )}
        </div>
      </div>
    </div>
  )
}

export default ReportsRentRoll
